import Request from "@/common/Request"
import store from '@/store/index'

export default class Cart {

    async addToCart(payload) {
        return (
            (await new Request().post("order", {
                "user_hash": store.getters.deviceToken,
                "products": payload
            }, { category: true}))
        ) 
    }

    async getOrderGroupedByCategory(orderId) {
        return (
            (await new Request().getWithfilter(orderId? `order/${orderId}` : "order",{
                "category": true,
                "user_hash": store.getters.deviceToken
            })) || { data: null }
        )
    }

    async getOrderProducts() {
        return (
            (await new Request().getWithfilter("order",{
                "user_hash": store.getters.deviceToken
            })) || { data: null }
        )
    }

    async deleteCartProduct(productData) {
        return (
            (await new Request().delete(`order/${productData.order_id}`,{
                "product_id": parseInt(productData.product_id),
                "user_hash": store.getters.deviceToken
            }, { category: true}))
        )
    }

}
